function Visa({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width="38"
      height="26"
      viewBox="0 0 38 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="38" height="26" fill="#1E1E1E" />
      <path
        d="M-7040 -2687C-7040 -2688.1 -7039.1 -2689 -7038 -2689H23108C23109.1 -2689 23110 -2688.1 23110 -2687V8649C23110 8650.1 23109.1 8651 23108 8651H-7038C-7039.1 8651 -7040 8650.1 -7040 8649V-2687Z"
        fill="#444444"
      />
      <path
        d="M-7038 -2688H23108V-2690H-7038V-2688ZM23109 -2687V8649H23111V-2687H23109ZM23108 8650H-7038V8652H23108V8650ZM-7039 8649V-2687H-7041V8649H-7039ZM-7038 8650C-7038.55 8650 -7039 8649.55 -7039 8649H-7041C-7041 8650.66 -7039.66 8652 -7038 8652V8650ZM23109 8649C23109 8649.55 23108.6 8650 23108 8650V8652C23109.7 8652 23111 8650.66 23111 8649H23109ZM23108 -2688C23108.6 -2688 23109 -2687.55 23109 -2687H23111C23111 -2688.66 23109.7 -2690 23108 -2690V-2688ZM-7038 -2690C-7039.66 -2690 -7041 -2688.66 -7041 -2687H-7039C-7039 -2687.55 -7038.55 -2688 -7038 -2688V-2690Z"
        fill="white"
        fillOpacity="0.1"
      />
      <g clipPath="url(#clip0_17652_9447)">
        <rect
          width="1440"
          height="1030"
          transform="translate(-1144 -825)"
          fill="#F5F5F5"
        />
        <mask id="path-3-inside-1_17652_9447" fill="white">
          <path d="M-989 -69H141V45H-989V-69Z" />
        </mask>
        <path
          d="M-989 -68H141V-70H-989V-68Z"
          fill="#E0E0E0"
          mask="url(#path-3-inside-1_17652_9447)"
        />
        <g opacity="0.5">
          <path
            d="M33.9036 1H3.71006C1.99975 1 0.613281 2.38647 0.613281 4.09677V21.9032C0.613281 23.6135 1.99975 25 3.71006 25H33.9036C35.6139 25 37.0004 23.6135 37.0004 21.9032V4.09677C37.0004 2.38647 35.6139 1 33.9036 1Z"
            fill="white"
            stroke="black"
            strokeOpacity="0.2"
            strokeWidth="0.5"
          />
          <path
            d="M4.54252 9.77137C3.73249 9.32709 2.80802 8.96977 1.77441 8.72181L1.81777 8.52871H6.05567C6.6301 8.54884 7.09621 8.72167 7.24788 9.33205L8.16889 13.7231L8.45103 15.0456L11.0306 8.52871H13.8159L9.67565 18.0755H6.89023L4.54252 9.77137ZM15.8647 18.0856H13.2307L14.8782 8.52871H17.5121L15.8647 18.0856ZM25.4133 8.76235L25.0551 10.8261L24.8168 10.7246C24.3402 10.5313 23.7111 10.3382 22.8547 10.3586C21.8148 10.3586 21.3484 10.7752 21.3376 11.182C21.3376 11.6294 21.9018 11.9243 22.8231 12.3615C24.3406 13.0427 25.0446 13.8763 25.034 14.9643C25.0127 16.9469 23.2134 18.2281 20.4496 18.2281C19.2679 18.2178 18.1297 17.9835 17.5119 17.7194L17.8805 15.5741L18.2274 15.7268C19.0837 16.083 19.6472 16.2352 20.6988 16.2352C21.4571 16.2352 22.2702 15.9401 22.2806 15.2998C22.2806 14.8829 21.9342 14.5777 20.9151 14.11C19.9181 13.6523 18.585 12.8899 18.6066 11.5172C18.6179 9.65677 20.4496 8.35547 23.0508 8.35547C24.0697 8.35547 24.8938 8.56897 25.4133 8.76235ZM28.9142 14.7H31.1035C30.9952 14.2221 30.4964 11.9345 30.4964 11.9345L30.3123 11.111C30.1823 11.4668 29.9548 12.0464 29.9658 12.026C29.9658 12.026 29.1311 14.1509 28.9142 14.7ZM32.1655 8.52871L34.2905 18.0855H31.8517C31.8517 18.0855 31.613 16.9874 31.5374 16.6519H28.1555C28.0577 16.906 27.6027 18.0855 27.6027 18.0855H24.8389L28.7514 9.32165C29.0225 8.7014 29.4998 8.52871 30.1281 8.52871H32.1655Z"
            fill="#171E6C"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_17652_9447">
          <rect
            width="1440"
            height="1030"
            fill="white"
            transform="translate(-1144 -825)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Visa;
